import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { InvitationShellLayout } from "~/components/invitation-shell-layout";

const JoinLayout = () => (
  <InvitationShellLayout>
    <Outlet />
  </InvitationShellLayout>
);

/**
 * Shared parent route for join flows (`/join` + `/join/board`).
 *
 * Child routes own invitation-kind logic. This parent only ensures the
 * user is authenticated and preserves the full destination in `redirect`.
 *
 * `location.href` is already pathname + search + hash with the origin
 * stripped. Interpolating `location.search` instead would throw: it is the
 * parsed search object, which TSR builds with `Object.create(null)`, so it
 * has no `toString` to convert.
 */
export const Route = createFileRoute("/join")({
  beforeLoad: ({ context, location }) => {
    if (!context.user) {
      throw redirect({
        to: "/login",
        search: { redirect: location.href },
        replace: true,
      });
    }
  },
  component: JoinLayout,
});
